<template>
	<v-container v-if="isStandalone" fluid pa-0 style="background-color: #F0F2F8;" fill-height class="d-flex flex-row">
		<StandaloneDocumentViewer v-if="isAuthenticated && $route.name === 'StandaloneDocumentViewer'"/>
		<StandaloneForgeViewer v-if="isAuthenticated && $route.name === 'StandaloneForgeViewer'"/>
	</v-container>
	<v-container v-else-if="isFreeRoute" fluid pa-0 style="background-color: #F0F2F8;" fill-height class="d-flex flex-column">
		<RouterContainer/>
	</v-container>
	<v-container v-else fluid pa-0 style="background-color: #F0F2F8;" fill-height class="d-flex flex-row">
		<Sidebar v-if="$store.userStore.state.isAuthenticated"/>
		<RouterContainer/>
		<GlobalModalsIndex v-if="$store.userStore.state.isAuthenticated" />
		<FileUploadCenter />
		<FloatingPanelsStack :show-global-floating-buttons="showGlobalFloatingButtons" />
		<AlertMessageCenter />
		<FirebaseController v-if="$store.userStore.state.isAuthenticated && $store.userStore.state.userInfo"/>
		<Reminders />
		
		<TasksManager />
	</v-container>
</template>

<script>
/* eslint-disable */
import Sidebar from './Sidebar'
import RouterContainer from './RouterContainer'
import GlobalModalsIndex from '../Globals/Modals/GlobalModalsIndex'
import FileUploadCenter from '@/components/Globals/Helpers/FileUploadCenter'
import TasksManager from '@/components/Globals/Helpers/TasksManager'
import AlertMessageCenter from '@/components/Globals/Helpers/AlertMessageCenter'
import FirebaseController from '@/components/Globals/Helpers/FirebaseController'
import Reminders from '@/components/Globals/Helpers/Reminders'
import StandaloneDocumentViewer from '@/components/Globals/Helpers/StandaloneDocumentViewer'
import StandaloneForgeViewer from '@/components/Globals/Helpers/StandaloneForgeViewer'
import FloatingPanelsStack from '@/components/Layout/Helpers/FloatingPanelsStack'

export default {
	name: 'MainLayout',
	components: { Sidebar, RouterContainer, GlobalModalsIndex, FileUploadCenter, FloatingPanelsStack, TasksManager, AlertMessageCenter, FirebaseController, Reminders, StandaloneDocumentViewer, StandaloneForgeViewer },
	data: () => ({}),
	computed: {
		standaloneRoutes() {
			return ['StandaloneDocumentViewer', 'StandaloneForgeViewer']
		},
		freeRoutes() {
			return ['Login', 'Register', 'ResetPassRequest', 'ResetPass', 'NewUserPassword', 'PrivacyPolicy', 'ConfirmUserDelete']
		},
		userInfo() {
			return this.$store.userStore.state.userInfo
		},
		isStandalone() {
			return this.standaloneRoutes.includes(this.$route.name)
		},
		isFreeRoute() {
			return this.freeRoutes.includes(this.$route.name)
		},
		isAuthenticated() {
			return this.$store.userStore.state.isAuthenticated
		},
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		showGlobalFloatingButtons() {
			return this.isAuthenticated && this.userInfo
		}
	}
};
</script>

<style scoped>
.free-header {
	display: flex;
	align-items: center;
	padding: 6px 12px;
	border-bottom: 1px solid rgba(0,0,0,0.04);
}
.laot-logo {
	height: 34px;
	margin-right: 8px;
}
@media (max-width: 600px) {
	.laot-logo { height: 28px; }
}
</style>
